import React, { useState, useEffect } from 'react';
import { ConstructorEventUpdateSQLStatus } from '../../../../Event/event';
const TrainTrackerExpress = () => {
  const scenarios = [
    { speedA: 60, distanceA: 180, speedB: 90, distanceB: 180 },
    { speedA: 50, distanceA: 200, speedB: 100, distanceB: 200 },
    { speedA: 75, distanceA: 225, speedB: 60, distanceB: 180 },
    { speedA: 80, distanceA: 240, speedB: 60, distanceB: 180 },
  ];

  const [index, setIndex] = useState(0);
  const [timeA, setTimeA] = useState('');
  const [timeB, setTimeB] = useState('');
  const [result, setResult] = useState('');
  const [showNext, setShowNext] = useState(false);
  const [trainPos, setTrainPos] = useState({ train1: '0%', train2: '0%' });

  const current = scenarios[index];

  useEffect(() => {
    setResult('');
    setTimeA('');
    setTimeB('');
    setShowNext(false);
    setTrainPos({ train1: '0%', train2: '0%' });

    setTimeout(() => {
      setTrainPos({
        train1: `${Math.random() * 50 + 30}%`,
        train2: `${Math.random() * 50 + 30}%`,
      });
    }, 500);
  }, [index]);

  const checkAnswers = () => {
    const correctA = current.distanceA / current.speedA;
    const correctB = current.distanceB / current.speedB;

    let msg = '';

    if (Math.abs(parseFloat(timeA) - correctA) < 0.1) {
      msg += `✅ Train A: Correct! (${correctA.toFixed(1)} hrs)<br>`;
    } else {
      msg += `❌ Train A: Should be ${correctA.toFixed(1)} hrs<br>`;
    }

    if (Math.abs(parseFloat(timeB) - correctB) < 0.1) {
      msg += `✅ Train B: Correct! (${correctB.toFixed(1)} hrs)<br>`;
    } else {
      msg += `❌ Train B: Should be ${correctB.toFixed(1)} hrs<br>`;
    }

    if((Math.abs(parseFloat(timeB) - correctB) < 0.1)&&(Math.abs(parseFloat(timeA) - correctA) < 0.1)){
          const responsedata = ConstructorEventUpdateSQLStatus();
                console.log("Event completed", responsedata);
    }

    if (correctA < correctB) {
      msg += `🚆 Train A arrives first!`;
    } else if (correctB < correctA) {
      msg += `🚄 Train B arrives first!`;
    } else {
      msg += `It's a tie! 🎯`;
    }

    setResult(msg);
    setShowNext(true);
  };

  const nextScenario = () => {
    setIndex((index + 1) % scenarios.length);
  };

  const styles = {
    body: {
      fontFamily: "'Comic Sans MS', cursive",
      background: 'linear-gradient(to bottom, #cceeff, #ffffff)',
      padding: 20,
      textAlign: 'center',
      minHeight: '100vh',
      overflowX: 'hidden',
    },
    h1: {
      color: '#1565c0',
      fontSize: '2.5em',
    },
    track: {
      position: 'relative',
      width: '100%',
      height: 150,
      background: '#ddd',
      margin: '20px auto',
      border: '3px dashed #888',
      borderRadius: 10,
    },
    train: {
      position: 'absolute',
      bottom: 10,
      fontSize: '2em',
      transition: 'left 2s ease-in-out',
    },
    scenario: {
      fontSize: 20,
      marginTop: 20,
    },
    inputArea: {
      marginTop: 20,
    },
    input: {
      fontSize: '1rem',
      padding: '6px 12px',
      borderRadius: 6,
      border: '2px solid #f9a825',
      textAlign: 'center',
      width: 'fit-content',
      marginLeft: 'auto',
      marginRight: 'auto',
      display: 'block',
      marginBottom: 10,
    },
    button: {
      fontSize: 18,
      padding: '10px 20px',
      backgroundColor: '#42a5f5',
      color: 'white',
      border: 'none',
      borderRadius: 8,
      marginTop: 15,
      cursor: 'pointer',
    },
    result: {
      fontSize: 18,
      marginTop: 20,
      fontWeight: 'bold',
    },
    next: {
      display: showNext ? 'block' : 'none',
      marginTop: 25,
    },
  };

  return (
    <div style={styles.body}>
      <style>{`
        @media (max-width: 600px) {
          h1 {
            font-size: 1.8em !important;
          }
          input {
            width: 90% !important;
            font-size: 1rem;
          }
          p {
            font-size: 1em;
          }
          .train-icon {
            font-size: 1.5em !important;
          }
        }
      `}</style>

      <h1 style={styles.h1}>🚂 Train Tracker Express</h1>
      <p style={styles.scenario}>
        Train A is going {current.speedA} km/h to travel {current.distanceA} km.<br />
        Train B is going {current.speedB} km/h to travel {current.distanceB} km.
      </p>

      {/* <div style={styles.track}>
        <div className="train-icon" style={{ ...styles.train, left: trainPos.train1 }}>🚂 A</div>
        <div className="train-icon" style={{ ...styles.train, left: trainPos.train2 }}>🚄 B</div>
      </div> */}

      <div style={styles.inputArea}>
        <p>How many hours will it take Train A to reach the city?</p>
        <input
          type="number"
          step="0.1"
          value={timeA}
          onChange={(e) => setTimeA(e.target.value)}
          style={styles.input}
        />{' '}
        hours
        <p>How many hours for Train B?</p>
        <input
          type="number"
          step="0.1"
          value={timeB}
          onChange={(e) => setTimeB(e.target.value)}
          style={styles.input}
        />{' '}
        hours
        <br />
        <button onClick={checkAnswers} style={styles.button}>Check Answer</button>
      </div>

      <div
        style={styles.result}
        dangerouslySetInnerHTML={{ __html: result }}
      ></div>

      <div style={styles.next}>
        <button onClick={nextScenario} style={styles.button}>Next ➡️</button>
      </div>
    </div>
  );
};

export default TrainTrackerExpress;
